var _g, _path, _path2, _g2, _path3, _path4, _g3, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g4, _path13, _path14, _path15, _path16, _path17, _g5, _path18, _path19, _g6, _path20, _path21, _path22, _path23, _path24, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProviders(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 651,
    height: 381,
    viewBox: "0 0 651 381",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 94.8468,
    y: 211.914,
    width: 126.125,
    height: 112.004,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.8468,
    y: 211.914,
    width: 126.125,
    height: 112.004,
    rx: 8,
    stroke: "#DADADA",
    strokeWidth: 0.427377
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M166.516 252.268C166.883 252.425 167.225 252.556 167.555 252.74C170.088 254.117 171.596 256.243 171.925 259.194C172.229 261.949 171.482 264.376 169.556 266.344C168.138 267.8 166.377 268.613 164.439 269.046C163.476 269.256 162.488 269.348 161.512 269.348C155.711 269.348 149.896 269.348 144.094 269.348C143.904 269.348 143.828 269.321 143.841 269.098C143.854 267.8 143.854 266.501 143.841 265.215C143.841 265.071 143.854 264.992 144.031 264.979C146.425 264.914 148.503 262.867 148.528 260.178C148.541 259.286 148.541 258.381 148.186 257.541C147.375 255.705 145.994 254.682 144.044 254.55C143.866 254.537 143.841 254.485 143.841 254.314C143.841 253.147 143.854 251.992 143.841 250.825C143.841 250.628 143.892 250.589 144.082 250.576C146.4 250.484 148.351 248.516 148.515 246.128C148.68 243.649 147.033 241.419 144.715 240.986C144.474 240.947 144.234 240.907 143.993 240.907C143.866 240.907 143.828 240.868 143.828 240.75C143.828 239.399 143.828 238.061 143.828 236.71C143.828 236.592 143.879 236.539 143.993 236.552C144.044 236.552 144.094 236.552 144.132 236.552C149.782 236.552 155.445 236.552 161.094 236.565C162.83 236.565 164.502 236.92 166.085 237.694C168.328 238.795 169.949 240.488 170.57 243.019C171.165 245.407 170.937 247.69 169.506 249.749C168.809 250.759 167.897 251.533 166.833 252.084C166.731 252.15 166.63 252.202 166.516 252.268ZM153.063 259.653C153.063 261.214 153.063 262.775 153.063 264.35C153.063 264.533 153.088 264.599 153.291 264.599C155.799 264.586 158.307 264.599 160.828 264.586C161.715 264.586 162.564 264.402 163.336 263.956C165.11 262.946 165.895 261.359 165.794 259.299C165.731 257.987 165.249 256.872 164.287 255.993C163.248 255.049 162.006 254.708 160.664 254.695C158.206 254.682 155.736 254.695 153.278 254.682C153.088 254.682 153.05 254.734 153.05 254.918C153.063 256.505 153.063 258.079 153.063 259.653ZM153.063 245.84C153.063 247.283 153.063 248.713 153.063 250.156C153.063 250.366 153.126 250.418 153.316 250.405C155.559 250.392 157.801 250.405 160.056 250.405C160.6 250.405 161.132 250.339 161.652 250.182C164.629 249.29 165.845 245.669 163.995 243.177C163.032 241.878 161.69 241.327 160.144 241.314C157.864 241.288 155.571 241.314 153.291 241.301C153.114 241.301 153.063 241.34 153.063 241.537C153.063 242.967 153.063 244.397 153.063 245.84Z",
    fill: "#292929"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M157.914 276.433C162.512 276.433 167.123 276.433 171.721 276.433C171.949 276.433 172 276.498 172 276.721C171.987 278.112 171.987 279.516 172 280.906C172 281.103 171.962 281.182 171.759 281.182C162.537 281.182 153.315 281.182 144.093 281.182C143.916 281.182 143.84 281.142 143.84 280.932C143.852 279.516 143.852 278.086 143.84 276.669C143.84 276.459 143.916 276.433 144.093 276.433C148.691 276.433 153.303 276.433 157.914 276.433Z",
    fill: "#149E49"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 430.029,
    y: 58.0813,
    width: 126.125,
    height: 112.004,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.029,
    y: 58.0813,
    width: 126.125,
    height: 112.004,
    rx: 8,
    stroke: "#DADADA",
    strokeWidth: 0.427377
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M513.334 82.2067C513.334 82.4133 513.334 82.4133 513.135 82.6199C508.571 90.4718 502.816 97.2906 495.87 102.87C490.909 106.796 485.55 109.895 479.597 111.755C477.017 112.581 474.437 112.994 471.857 113.201C471.46 113.201 471.46 113.201 471.46 112.994C472.056 104.729 475.032 97.9105 480.787 92.3315C482.97 90.2652 485.55 88.8188 488.329 87.579C491.901 85.926 495.671 84.8928 499.442 84.0663C501.625 83.6531 504.006 83.2398 506.388 82.8266C508.372 82.6199 510.357 82.4133 512.341 82.2067C512.54 82.2067 512.937 82.2067 513.334 82.2067Z",
    fill: "#799A43"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M472.65 120.226C475.627 120.02 478.604 119.4 481.382 118.16C485.748 116.507 489.717 114.027 493.487 110.928C498.647 106.589 503.013 101.63 506.784 95.8441C508.768 92.7447 510.554 89.6453 512.142 86.3392C512.737 85.0994 513.333 83.653 513.73 82.2066V82C513.928 82 513.928 82.2066 513.928 82.4133C514.126 83.653 514.325 85.0994 514.523 86.3392C514.722 87.9922 514.722 89.8519 514.722 91.5049C514.523 98.1171 513.134 104.523 510.554 110.515C509.364 113.408 507.776 116.094 505.792 118.367C502.616 122.293 498.647 124.772 494.083 125.805C492.098 126.219 490.114 126.425 488.129 126.425C484.359 126.219 480.787 125.599 477.413 123.739C475.825 122.913 474.238 121.673 473.047 120.226C472.848 120.433 472.848 120.433 472.65 120.226C472.848 120.226 472.848 120.226 472.65 120.226Z",
    fill: "#9FCA5A"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 262.438,
    y: 58.0813,
    width: 126.125,
    height: 112.004,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.438,
    y: 58.0813,
    width: 126.125,
    height: 112.004,
    rx: 8,
    stroke: "#DADADA",
    strokeWidth: 0.427377
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M303.359 123.603C303.359 114.095 303.359 104.488 303.359 95.0792C304.031 93.9898 304.991 94.0888 305.855 94.0888C319.007 94.0888 332.159 94.0888 345.216 94.0888C347.136 94.0888 348 94.8812 348 96.862C348 105.181 347.904 113.501 348 121.82C348 123.9 347.232 124.594 345.312 124.594C332.159 124.495 319.007 124.495 305.855 124.495C305.087 124.495 304.223 124.693 303.359 123.603ZM312.959 109.341C312.959 116.571 318.719 122.415 325.727 122.415C332.543 122.316 338.304 116.373 338.304 109.242C338.304 101.913 332.543 96.0697 325.343 96.1687C318.527 96.1687 312.959 102.111 312.959 109.341Z",
    fill: "#516889"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M328.415 92.9003C326.975 90.5234 325.151 88.5425 322.559 87.354C324.479 83.2933 329.376 81.1144 333.888 82.1048C338.976 83.2933 342.528 87.6512 342.528 92.9003C337.92 92.9003 333.312 92.9003 328.415 92.9003Z",
    fill: "#FCC317"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M309.311 92.9004C313.631 85.7694 322.943 85.7694 327.071 92.9004C321.023 92.9004 315.167 92.9004 309.311 92.9004Z",
    fill: "#FCC317"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M312.959 109.341C312.959 102.111 318.527 96.1687 325.343 96.1687C332.544 96.0697 338.304 101.913 338.304 109.242C338.304 116.274 332.544 122.316 325.727 122.415C318.719 122.415 312.959 116.571 312.959 109.341ZM325.535 121.226C331.968 121.325 337.248 115.977 337.248 109.242C337.248 102.606 332.256 97.2582 325.823 97.1591C319.295 97.0601 314.111 102.309 314.015 108.945C314.015 115.779 319.007 121.127 325.535 121.226Z",
    fill: "#FEFEFE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M325.536 121.226C319.103 121.127 314.015 115.779 314.111 109.044C314.207 102.309 319.391 97.0602 325.92 97.2582C332.256 97.3573 337.344 102.706 337.344 109.341C337.248 115.977 331.968 121.226 325.536 121.226ZM324.959 102.012C324.191 100.923 325.343 99.3381 323.807 98.7439C322.463 99.5362 323.519 101.022 322.847 101.913C321.887 102.408 320.639 101.715 319.679 102.408C319.871 103.399 321.023 102.904 321.215 104.29C321.215 107.261 321.215 110.728 321.215 114.194C321.023 115.086 319.583 114.293 319.679 115.581C320.639 116.175 321.887 115.383 322.751 115.878C323.423 116.868 322.367 118.354 323.999 118.948C325.055 118.156 324.287 116.868 324.767 115.977C325.247 115.68 325.632 115.68 325.824 115.878C326.496 116.967 325.343 118.651 327.264 118.849C327.84 117.859 327.36 116.769 327.744 115.779C329.952 115.383 332.544 115.185 332.736 112.015C332.928 109.44 330.816 108.945 328.704 108.252C330.24 107.459 332.16 107.162 331.968 104.983C331.776 102.111 329.184 102.507 327.648 101.814C327.072 100.725 327.84 99.4371 326.976 98.6448C325.728 98.7439 326.016 99.7343 325.92 100.428C326.112 101.418 326.208 102.21 324.959 102.012Z",
    fill: "#516889"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M324.96 102.012C326.208 102.309 326.112 101.418 326.208 100.626C326.208 99.9323 326.016 98.9419 327.264 98.8428C328.128 99.7342 327.456 100.923 327.936 102.012C329.472 102.705 332.064 102.309 332.256 105.181C332.352 107.36 330.528 107.658 328.992 108.45C331.008 109.143 333.12 109.638 333.024 112.213C332.832 115.284 330.24 115.581 328.032 115.977C327.552 116.967 328.128 118.057 327.552 119.047C325.632 118.75 326.784 117.165 326.112 116.076C325.92 115.878 325.44 115.878 325.056 116.175C324.576 117.066 325.344 118.354 324.288 119.146C322.655 118.552 323.808 117.066 323.039 116.076C322.271 115.581 320.927 116.274 319.967 115.779C319.871 114.491 321.311 115.284 321.503 114.392C321.503 110.926 321.503 107.36 321.503 104.488C321.311 103.102 320.159 103.597 319.967 102.606C320.927 101.913 322.175 102.606 323.135 102.111C323.808 101.22 322.751 99.7342 324.096 98.9419C325.344 99.338 324.192 100.923 324.96 102.012ZM324.864 114.392C326.304 115.185 327.648 115.086 328.608 113.996C329.568 112.907 329.664 111.421 328.896 110.233C327.936 108.648 326.4 108.846 324.768 109.044C324.576 110.827 324.576 112.61 324.864 114.392ZM324.672 107.757C326.304 107.856 327.744 108.054 328.608 106.469C329.088 105.479 328.896 104.488 328.224 103.696C327.264 102.606 326.208 102.804 324.96 103.399C324.48 104.785 324.672 106.172 324.672 107.757Z",
    fill: "#FEFEFE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M324.863 114.392C324.575 112.511 324.575 110.827 324.767 108.945C326.399 108.846 327.935 108.549 328.895 110.134C329.567 111.421 329.567 112.808 328.607 113.897C327.647 115.086 326.303 115.185 324.863 114.392Z",
    fill: "#516889"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M324.671 107.757C324.671 106.172 324.479 104.785 324.863 103.399C326.111 102.805 327.263 102.705 328.127 103.696C328.799 104.488 328.991 105.479 328.511 106.469C327.743 108.054 326.303 107.856 324.671 107.757Z",
    fill: "#516889"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 94.8465,
    y: 58.0813,
    width: 126.125,
    height: 112.004,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.8465,
    y: 58.0813,
    width: 126.125,
    height: 112.004,
    rx: 8,
    stroke: "#DADADA",
    strokeWidth: 0.427377
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M156.763 77.8086C161.83 83.0355 166.992 88.361 172.154 93.6864C170.338 95.5602 168.426 97.434 166.418 99.4064C163.264 96.152 160.109 92.7989 156.763 89.3472C153.417 92.8975 150.167 96.2506 147.012 99.6037C144.909 97.5326 143.093 95.5602 141.277 93.7851C146.439 88.4596 151.601 83.1341 156.763 77.8086Z",
    fill: "#F2BA32"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M172.154 114.002C166.991 119.328 161.829 124.653 156.763 129.88C151.601 124.653 146.343 119.229 141.181 113.904C142.997 112.03 144.814 110.156 146.725 108.282C149.88 111.537 153.13 114.89 156.38 118.243C159.822 114.693 163.072 111.339 166.322 107.986C168.425 110.156 170.337 112.128 172.154 114.002Z",
    fill: "#F2BA32"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M156.572 109.663C154.755 107.789 152.843 105.817 151.123 104.042C153.035 102.069 154.947 100.097 156.763 98.3216C158.484 100.097 160.395 102.069 162.212 103.943C160.395 105.718 158.484 107.691 156.572 109.663Z",
    fill: "#F2BA32"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M176.551 98.223C178.272 99.9981 180.184 101.971 182 103.844C180.184 105.718 178.272 107.691 176.455 109.564C174.735 107.789 172.823 105.817 171.007 103.943C172.823 102.069 174.639 100.195 176.551 98.223Z",
    fill: "#F2BA32"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M142.424 103.943C140.703 105.718 138.791 107.691 136.975 109.564C135.159 107.691 133.247 105.817 131.526 104.042C133.342 102.168 135.254 100.195 136.975 98.4202C138.6 100.097 140.512 101.971 142.424 103.943Z",
    fill: "#F2BA32"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 262.438,
    y: 211.914,
    width: 126.125,
    height: 112.004,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.438,
    y: 211.914,
    width: 126.125,
    height: 112.004,
    rx: 8,
    stroke: "#DADADA",
    strokeWidth: 0.427377
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M347.934 269.654C336.719 269.654 325.505 269.654 314.224 269.654C314.224 263.701 314.224 257.816 314.224 251.863C315.618 251.863 317.011 251.863 318.471 251.863C318.471 256.293 318.471 260.724 318.471 265.154C326.898 265.154 335.193 265.154 343.62 265.154C343.62 256.432 343.62 247.709 343.62 238.987C335.259 238.987 326.898 238.987 318.537 238.987C318.537 239.818 318.537 240.579 318.537 241.41C317.077 241.41 315.684 241.41 314.224 241.41C314.224 239.125 314.224 236.841 314.224 234.487C325.438 234.487 336.719 234.487 348 234.487C347.934 246.186 347.934 257.886 347.934 269.654Z",
    fill: "#2281C4"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M305.199 244.387C316.414 244.387 327.695 244.387 338.909 244.387C338.909 250.34 338.909 256.224 338.909 262.178C337.515 262.178 336.122 262.178 334.662 262.178C334.662 257.747 334.662 253.317 334.662 248.886C326.235 248.886 317.874 248.886 309.513 248.886C309.513 257.609 309.513 266.331 309.513 275.054C317.874 275.054 326.235 275.054 334.662 275.054C334.662 274.292 334.662 273.462 334.662 272.631C336.122 272.631 337.515 272.631 338.975 272.631C338.975 274.915 338.975 277.2 338.975 279.484C327.761 279.484 316.546 279.484 305.266 279.484C305.199 267.854 305.199 256.155 305.199 244.387Z",
    fill: "#2281C4"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 430.029,
    y: 211.914,
    width: 126.125,
    height: 112.004,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.029,
    y: 211.914,
    width: 126.125,
    height: 112.004,
    rx: 8,
    stroke: "#DADADA",
    strokeWidth: 0.427377
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M493.49 234.271C497.738 234.271 501.987 234.271 506.235 234.271C508.768 234.271 511.219 234.692 513.343 236.294C516.121 238.233 517.51 241.014 517.918 244.47C518 245.397 518 246.324 518 247.336C518 255.849 518 264.277 518 272.79C518 275.403 517.591 277.932 516.039 280.123C514.078 283.073 511.219 284.506 507.869 284.843C506.889 284.928 505.99 284.928 505.009 284.928C496.921 284.928 488.833 284.928 480.744 284.928C478.293 284.928 475.924 284.506 473.881 283.158C471.185 281.388 469.633 278.859 469.143 275.572C468.979 274.392 468.898 273.212 468.898 272.032C468.898 263.519 468.898 255.006 468.898 246.493C468.898 243.88 469.306 241.351 470.858 239.16C472.819 236.294 475.515 234.777 478.865 234.44C479.845 234.271 480.826 234.271 481.806 234.271C485.646 234.271 489.568 234.271 493.49 234.271ZM481.97 259.473C481.97 263.35 483.522 266.806 486.382 269.25C491.12 273.296 498.065 273.127 502.558 268.829C502.885 268.492 502.804 268.407 502.558 268.07C501.496 267.059 500.516 265.963 499.536 264.952C499.209 264.614 499.045 264.614 498.718 264.952C495.042 268.07 489.731 266.722 487.852 262.17C486.3 258.461 488.424 253.91 492.101 252.73C494.552 251.971 496.758 252.393 498.718 254.079C499.045 254.331 499.209 254.331 499.536 254.079C500.516 252.983 501.578 251.971 502.64 250.876C502.885 250.623 502.967 250.454 502.64 250.201C499.699 247.504 496.267 246.408 492.346 246.998C486.3 248.094 481.97 253.32 481.97 259.473Z",
    fill: "#1652EF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M481.97 259.473C481.97 253.32 486.3 248.094 492.264 247.083C496.186 246.408 499.618 247.588 502.559 250.286C502.886 250.538 502.804 250.707 502.559 250.96C501.497 251.971 500.516 253.067 499.454 254.163C499.127 254.5 498.964 254.416 498.637 254.163C496.676 252.477 494.47 252.056 492.019 252.814C488.261 253.994 486.219 258.546 487.771 262.254C489.65 266.806 494.961 268.154 498.637 265.036C498.964 264.783 499.127 264.699 499.454 265.036C500.435 266.132 501.497 267.143 502.477 268.154C502.722 268.407 502.804 268.576 502.477 268.913C497.902 273.212 490.957 273.38 486.3 269.334C483.441 266.806 481.888 263.35 481.97 259.473Z",
    fill: "#FAFBFE"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M117.696 4.38849V31.3885",
    stroke: "#1674A9",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4719 17.6053L88 41.5",
    stroke: "#1674A9",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1535 59.5389L76 71",
    stroke: "#1674A9",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 116,
    y: 141,
    width: 78,
    height: 5.73,
    rx: 2.865,
    fill: "#B5B5B5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 128,
    y: 292,
    width: 54,
    height: 5.75,
    rx: 2.875,
    fill: "#B5B5B5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 302,
    y: 138,
    width: 46,
    height: 5.75,
    rx: 2.875,
    fill: "#B5B5B5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 302,
    y: 292,
    width: 46,
    height: 5.75,
    rx: 2.875,
    fill: "#B5B5B5"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 468,
    y: 138,
    width: 50,
    height: 5.75,
    rx: 2.875,
    fill: "#B5B5B5"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 454,
    y: 292,
    width: 78,
    height: 5.75,
    rx: 2.875,
    fill: "#B5B5B5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 90.6331,
    y: 209.701,
    width: 134.552,
    height: 120.432,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.411765 0 0 0 0 0.439216 0 0 0 0 0.458824 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d",
    x: 425.815,
    y: 55.8676,
    width: 134.552,
    height: 120.432,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.411765 0 0 0 0 0.439216 0 0 0 0 0.458824 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d",
    x: 258.224,
    y: 55.8676,
    width: 134.552,
    height: 120.432,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.411765 0 0 0 0 0.439216 0 0 0 0 0.458824 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d",
    x: 90.6328,
    y: 55.8676,
    width: 134.552,
    height: 120.432,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.411765 0 0 0 0 0.439216 0 0 0 0 0.458824 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d",
    x: 258.224,
    y: 209.701,
    width: 134.552,
    height: 120.432,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.411765 0 0 0 0 0.439216 0 0 0 0 0.458824 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d",
    x: 425.815,
    y: 209.701,
    width: 134.552,
    height: 120.432,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.411765 0 0 0 0 0.439216 0 0 0 0 0.458824 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProviders);
export default __webpack_public_path__ + "static/media/providers.37a99c96a91a795f6a721dc188f1a34e.svg";
export { ForwardRef as ReactComponent };